var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 138,
    viewBox: "0 0 169 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5027 136.747C34.1652 136.345 33.8713 136.017 33.6098 135.57",
    stroke: "white",
    strokeWidth: 0.7362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9435 133.244C24.0134 121.083 22.3422 105.161 27.028 91.2188C32.265 75.9546 44.8813 63.3733 60.0411 57.4043C68.3318 54.1539 78.1902 52.8864 85.4977 57.7115C87.3354 58.9364 89.0874 60.7115 89.4501 62.8994C89.9885 66.0845 87.0735 69.2899 83.8816 69.7573C80.6137 70.2691 77.3628 68.3709 75.5223 65.7476C73.6817 63.1243 73.0125 59.7157 72.9846 56.532C72.857 46.9064 77.6171 37.6213 84.5651 30.8563C92.6619 22.9193 103.806 18.0997 115.121 17.58C118.487 17.4106 121.8 17.6725 125.092 18.2468",
    stroke: "white",
    strokeWidth: 0.7362,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.36 3.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.439 18.459C126.917 18.5793 127.395 18.6996 127.873 18.8199",
    stroke: "white",
    strokeWidth: 0.7362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.717 24.1713C132.467 24.2328 133.15 23.833 133.507 23.224L134.038 22.2138L138.111 22.7307L134.849 31.4396C136.173 31.2647 137.388 30.5539 137.994 29.4993L141.707 23.1273L143.999 23.3864C145.302 23.5238 146.691 23.111 147.58 22.1911C146.97 21.1481 145.752 20.4604 144.373 20.3674L142.124 20.1828L139.917 13.274C139.535 12.0977 138.533 11.0833 137.295 10.708L138.497 19.9052L134.434 19.5817L134.095 18.4799C133.899 17.795 133.278 17.2578 132.529 17.1962L131.66 17.1046L132.425 19.4572C131.567 19.559 130.493 19.9875 130.483 20.4933C130.397 21.0435 131.332 21.5965 132.136 21.926L130.848 24.0796L131.717 24.1713Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrF);
export default __webpack_public_path__ + "static/media/GrF.f6c90e86bd85a57e37e554edb3ae45e5.svg";
export { ForwardRef as ReactComponent };